import { POST } from "./_config";

export const loginAPI = async (body) => await POST("/auth/login", body);
